module.exports = __webpack_public_path__ + "img/Inactive_Linckard.563519d.svg";